import {AccessControlProps} from 'modules/access-controls/types';
import {AddressProps} from 'modules/addresses/types';
import {
  MotorcycleProps,
  translatedMotorcycleProps,
} from 'modules/delivery-men/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface ProfileProps
  extends Pick<UserProps, 'name' | 'password' | 'id' | 'accessControls'> {
  savedFields: {
    [key: string]: string[];
  };
}

export interface UserProps {
  id: string;
  name: string;
  email: string;
  phone?: string;
  emergencyPhone?: string;
  cpf: string;
  cnpj?: string;
  cnh?: string;
  homeAddress?: AddressProps;
  password: string;
  accessControls: AccessControlProps[];
  active: boolean;
  ratting: number;
  numberOfDeliveries?: number;
  profilePicture?: string;
  motorcycle?: MotorcycleProps;
  number: number;
  createdAt: Date;
  phoneConfirmed?: boolean;
  pixKey?: string;
}

export interface UsersMeGroup {
  id: string;
  name: string;
}

export interface ProfilePictureProps {
  id: string;
  key: string;
  url: string;
  mimetype: string;
}

export interface DriverVehiclesHistoryProps {
  id: string;
  registrationDate: Date;
}

export const translatedUserProps: TranslatedKeys<UserProps> = {
  name: 'Nome',
  email: 'Email',
  phone: 'Telefone',
  emergencyPhone: 'Telefone de emergência',
  cpf: 'Cpf',
  cnpj: 'Cnpj',
  cnh: 'Cnh',
  homeAddress: 'Endereço',
  password: 'Senha',
  active: 'Ativo?',
  accessControls: 'Controles de acesso',
  ratting: 'Avaliação',
  numberOfDeliveries: 'Número de entregas',
  profilePicture: 'Foto de perfil',
  motorcycle: translatedMotorcycleProps,
  number: 'Número',
  createdAt: 'Data de cadastro',
  phoneConfirmed: 'Telefone confirmado?',
  pixKey: 'Chave pix',
};
